import type { FC, ReactNode } from "react";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import type { SxProps, Theme } from "@mui/material/styles";
import { TriangleAlertIcon } from "../shared/icons";
import { mergeSx } from "../shared/mergeSx";

export const SharedProcessingWarning: FC<{ sx?: SxProps<Theme>; children: ReactNode }> = ({ sx, children }) => (
  <Alert
    severity="warning"
    icon={<TriangleAlertIcon size={16} color={theme => theme.palette.warning.main} />}
    sx={mergeSx({ "padding": "3px 16px", "& .MuiAlert-icon": { py: "10px" } }, sx)}
  >
    <Stack sx={{ gap: 0.5, minWidth: 0, overflowWrap: "anywhere" }}>{children}</Stack>
  </Alert>
);
